import { render, staticRenderFns } from "./paperLook.vue?vue&type=template&id=e2652846&scoped=true&"
import script from "./paperLook.vue?vue&type=script&lang=js&"
export * from "./paperLook.vue?vue&type=script&lang=js&"
import style0 from "./paperLook.vue?vue&type=style&index=0&id=e2652846&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2652846",
  null
  
)

export default component.exports